import { FormlyFieldConfig } from "@ngx-formly/core";

export function maxLengthValidatorMessage(error: any, field: FormlyFieldConfig) {
  return `${field.formControl.value.length}/${field.props.maxLength} caractères autorisés`;
}

export function maxValidatorMessage(error: any, field: FormlyFieldConfig) {
  return `Valeur maximale autorisée : ${field.props.max}`;
}

export function minValidatorMessage(error: any, field: FormlyFieldConfig) {
  return `Valeur minimale autorisée : ${field.props.max}`;
}